export default {"src":"/_next/static/media/ic_notice.7fad6036.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};